import { Comment } from '../../store/Comment';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getComments = (entityId: string, entityType: string) => {
  return apiService.callExternalApi<Comment[]>({
    url: `${API_SERVER_URL}/comments/entity/${entityId}/type/${entityType}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const createCommentData = (comment: Comment) => {
  return apiService.callExternalApi<Comment>({
    url: `${API_SERVER_URL}/comments`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: comment
  });
};

export const updateCommentData = async (comment: Comment) => {
  return await apiService.callExternalApi<Comment>({
    url: `${API_SERVER_URL}/comments/${comment.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: comment
  });
};

export const archiveCommentData = (id: string) => {
  return apiService.callExternalApi<Comment>({
    url: `${API_SERVER_URL}/comments/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};
